//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/customerService/lostAndFound/goodsType';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        typeName: [{
          required: true,
          message: '请输入物品类型名称',
          trigger: 'blur'
        }]
      },
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};